export default {
    surgeryCategory: 'Surgery Category',
    surgeryCategoryTitle: 'Title',
    surgeryCategoryStatus: 'Status',
    surgeryCategories: 'Surgery Categories',
    editSurgeryCategory: 'Edit Surgery Category',
    addSurgeryCategory: 'Add Surgery Category',
}